import { gql } from '@apollo/client'

export const ORDER_FRAGMENT = gql`
  fragment OrderFields on ShopOrder {
    id
    uuid
    createdAt
    updatedAt
    preparationStatus
    fulfillmentStatus
    totalPriceFormatted
    totalDeliveryCostMoney
    totalDeliveryCostMoneyFormatted
    totalShippingCostMoney
    totalShippingCostMoneyFormatted
    totalDiscountMoney
    totalDiscountMoneyFormatted
    totalTaxMoney
    totalTaxMoneyFormatted
    driverTipMoney
    driverTipMoneyFormatted
    totalGiftCardMoney
    totalGiftCardMoneyFormatted
    totalMoneyFormatted

    fulfillment {
      kind
      scheduleType
      fulfillmentAt
    }

    lineItems {
      id
      note
      quantity
      totalMoneyFormatted

      orderable {
        name
        categoryName
        variantName

        variantPrice {
          format
        }
      }

      modifiers {
        name
        priceFormatted
      }
    }

    externalDelivery {
      state
      estimatedDeliveryTime
      trackingUrl
    }
  }
`
